import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { catalogProduct } from './catalog-product.routing';
import { SharedModule } from '@app/shared/shared.module';
import { ProductCatalogComponent } from './ProductCatalog/ProductCatalog.component';
import { CatalogCardsComponent } from './catalog-cards/catalog-cards.component';
import { CatalogListComponent } from './catalog-list/catalog-list.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzImageModule as NzExperimentalImageModule } from 'ng-zorro-antd/experimental/image';
import { CatalogSharedModule } from './CatalogShared.module';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { TranslateModule } from '@ngx-translate/core';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { FormsModule } from '@angular/forms';
import { PriceFormatPipe } from './priceFormat.pipe';


@NgModule({
  imports: [
    CommonModule,
     SharedModule,
    catalogProduct,
    NzUploadModule,
    NzIconModule,
    NzModalModule,
    // NzImageModule,
     NzExperimentalImageModule,
     CatalogSharedModule,
     NzPageHeaderModule,
     NzIconModule,
     TranslateModule,
     NzCheckboxModule,
     FormsModule,
     
  ],
  declarations:
   [	
    CatalogCardsComponent,
    CatalogListComponent,
    ProductDetailsComponent,
    ProductCatalogComponent,
    PriceFormatPipe   
   ],
 

})
export class CatalogProductModule { }
